module.exports = __webpack_public_path__ + "img/intetgral-detail.0d5dad05.png";